module.exports = __webpack_public_path__ + "media/images/childcare/card-desktop@3x-64341130c44545a4a4627345a0a531e7.jpg";